<template>
    <li>
        <div class="title"><span>ターゲット</span></div>
        <div class="detail">
            <p><span>{{ $store.state.register.form.target_min }}代 〜 {{ $store.state.register.form.target_max }}代</span></p>
        </div>
    </li>
</template>